import styled from "styled-components";

export const WinTextDefaultBox = styled.div`
      font-size: 1.4rem;

      @media ${({theme}) => theme.mediaQuery.portrait} {
        text-align: center;
      }
    
    @media ${({theme}) => `${theme.mediaQuery.lAndAbove} and ${theme.mediaQuery.landscape}`} {
        max-width: 220px;
        font-size: 2rem;
    }

    @media ${({theme}) => `${theme.mediaQuery.landscape} and ${theme.mediaQuery.mAndBelow}`}{ {
        max-width: 150px;
    } 
`;